import { xmlRpcEndpoint } from '@/services/Authentication';
import {xmlRpcClient} from './client';

// Upload contact list
const uploadContacts = (base64data: any) => {
  const verbCreate = 'instancename.uploadcontacts';
  const paramsCreate = [
        {
            BASE64: base64data
        },
    ];
  return client(verbCreate, paramsCreate);
};

const client = async (verb: any, params: any) => {
  const retData = await xmlRpcClient(xmlRpcEndpoint(), verb, params);
  return retData;
};

export { uploadContacts };
